// extracted by mini-css-extract-plugin
export default {"icon":"StateStatusIcons_icon__eOFHy"};